<template>
  <div v-if="users !== null">
    <v-row class="flex-wrap my-3 ml-3">
      <!-- search -->
      <SearchInput
        v-model="search"
        class="ml-3 mr-5"
        :loading="searchLoading"
      />
    </v-row>

    <v-data-table-server
      :items="users"
      :headers="headers"
      item-value="id"
      :items-per-page-options="[10, 25, 50, 100]"
      :items-per-page-text="$t('DataTable.RowsPerPage')"
      :items-length="pagination.totalItems"
      @update:options="syncPagination"
    >
      <template #item="{ item }">
        <tr
          :class="{ pointer: is_admin }"
          @click="retrieve(item.id)"
        >
          <!-- avatar and user name -->
          <td style="white-space: nowrap">
            <v-row class="justify-center ml-1">
              <v-layout
                row
                class="align-center"
              >
                <v-icon
                  v-if="item.is_active === false"
                  color="error"
                  class="mr-2"
                  icon="mdi-minus-circle"
                />
                <OpAvatar
                  class="mr-2"
                  :size="25"
                  :profile="item"
                />
                <UserFullName :profile="item" />
              </v-layout>
            </v-row>
          </td>

          <!-- email -->
          <td style="white-space: nowrap">
            {{ item.email.slice(item.email.indexOf('_') + 1) }}
          </td>

          <!-- deleted date -->
          <td>
            {{ $filters.calendar(item.deleted_at_unix) }}
          </td>
        </tr>
      </template>

      <template #no-data>
        <v-layout class="text-grey justify-center">
          {{ $t('NoItems') }}
        </v-layout>
      </template>
    </v-data-table-server>

    <!-- dialog to restore deleted user -->
    <SimpleCardDialog
      v-if="is_admin"
      v-model:dialog="editDialog"
      :max-width="'600'"
      :title="$t('User.ReturnDeletedUser')"
    >
      <router-view />
      <template #actions>
        <ActionButton
          close
          @click="editDialog=false"
        />
      </template>
    </SimpleCardDialog>
  </div>
  <div
    v-else
    class="pa-3"
  >
    ...
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'
import DrfSyncDataTableMixin from './mixins/DrfSyncDataTableMixin'
import SimpleCardDialog from '@/components/parts/dialog/SimpleCardDialog'
import ActionButton from '@/components/parts/button/ActionButton'
import SearchInput from '@/components/parts/inputs/SearchInput'
import OpAvatar from '@/components/parts/OpAvatar'
import UserFullName from '@/components/parts/UserFullName'

export default {
  components: {
    UserFullName,
    OpAvatar,
    SearchInput,
    ActionButton,
    SimpleCardDialog
  },
  mixins: [ServiceIconMixin, DrfSyncDataTableMixin],
  props: {
    selectedGroups: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      users: null,
      editDialog: false,
      currentData: null,
      loadingList: false
    }
  },
  computed: {
    ...mapGetters(['ui', 'login']),
    searchLoading () {
      return this.loadingList && this.search !== null
    },
    is_admin () {
      return Boolean(this.login.profile.is_admin)
    },
    headers () {
      return [
        {
          title: this.$t('User.UserName'),
          sortable: true,
          key: 'first_name_en'
        },
        { title: this.$t('User.EmailAddress'), sortable: true, key: 'email' },
        { title: this.$t('User.Deleted'), sortable: true, key: 'deleted_at_unix' }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      this.openCloseEditDialog()
    },
    editDialog () {
      if (this.editDialog === false) {
        this.$router.push({ path: '/deleted-manage-accounts' })
        this.getList()
      }
    },
    'selectedGroups' () { this.getListWatchDebounce() }
  },
  created () {
    this.pagination = { descending: true, page: 1, rowsPerPage: 10, sortBy: 'deleted_at_unix' }
    this.getList()
  },
  mounted () {
    setTimeout(() => {
      this.openCloseEditDialog()
    }, 3000)
  },
  methods: {
    getList () {
      let url = 'deleted-users/'

      this.loadingList = true
      let params = this.getSyncParams()
      params.user_groups = this.selectedGroups
      this.$http(url, { params: params }).then((res) => {
        this.users = res.data.results
        this.applySyncData(res)
        this.loadingList = false
      })
    },
    retrieve (id) {
      if (this.is_admin) {
        this.$router.push({ path: `/deleted-manage-accounts/${id}` })
      }
    },
    openCloseEditDialog () {
      this.editDialog = Boolean(this.$route.params.id)
    }
  }
}
</script>
